/*
* @Author: tengmaoqing
* @Date:   2018-04-17 11:53:16
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:14:12
*/
// import parse from 'url-parse';
import createInstance from './instanceCreator';

/**
 * 手动维护 http 实例，每次 new 一个 app 都需要new 一个 http 实例，该方案主要针对 ssr，在尽量少的改动原有代码基础上，实现实例管理
 * 当 运行时间长后 可能 httpId 会很大，导致未知问题。 同一时刻如果 id 重复也可能会有问题
 */
const instances = {};
let httpId = 'init';

export const getHttpId = () => {
  return httpId;
};

export const getHttpInstance = () => {
  return instances[httpId];
};

export const newHttp = config => {
  httpId = Math.random().toString(32).slice(2);
  instances[httpId] = {
    http: createInstance(),
    apiHost: config.apiHost,
    Id: httpId
  };
  return instances[httpId];
};

export const removeHttpInstanceById = (httpId) => {
  instances[httpId] = null;
  delete instances[httpId];
};

export const getProducts = (categoryId = '', brandId = '', pageIndex = 1, pageSize = 20) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getProductList?classId=${categoryId}&brandId=${brandId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
};

export const getProductsByKey = (keyword = '', pageIndex = 1, pageSize = 20, classId) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getProductList?keyword=${keyword}&pageIndex=${pageIndex}&pageSize=${pageSize}`, { classId });
};

export const getBrands = (categoryId, pageSize = 100) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getBrandList?classId=${categoryId}&pageSize=${pageSize}`);
};

export const getCategory = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getCategoryList`);
};

export const getProductParams = productId => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getProductParam?productId=${productId}`);
};

export const evaluate = (productId, select) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/evaluate`, {select, productId});
};

export const getEvInfo = evaluateid => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getEvaluateResult?evaluateid=${evaluateid}&time=${new Date().getTime()}`);
};

export const getPayway = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getPayway`);
};

export const getRecycleNum = (productId) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getRecycleNum?productId=${productId}`);
};

export const createOrder = ({ evaluateid, tel, payType, regionId, recycleType, time, province, city, county, address, activityId, couponId, payAccount, payName, bankName, userName, imei, thirdCouponId, cardNumber, discountAmount, discountInfo, discountId, preOrderId, zmOrderNo, credFlag, sesameSignNo, externalNo, storeId }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/placeOrder`, {
    evaluateid,
    tel,
    payType,
    regionId,
    recycleType,
    time,
    province,
    city,
    county,
    address,
    activityId,
    couponId,
    payAccount,
    payName,
    preOrderId,
    discountId,
    discountInfo,
    discountAmount,
    bankName,
    userName,
    imei,
    // 第三方券ID， vivo 等
    thirdCouponId,
    // 快遞柜回收
    cardNumber,
    zmOrderNo,
    credFlag,
    sesameSignNo,
    externalNo,
    // 到店上门
    storeId
  });
};

export const getTempOrder = orderNum => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/order/getOrderResult?orderNum=${orderNum}`);
};

export const getSfCity = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Common/getSfCity`);
};

export const getHsbCity = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Common/getHsbCity`);
};

export const supportVisitTime = (body = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/Common/supportVisitTime`, body);
};

export const getVisitTime = (body = {}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/optimize/getServiceTime`, body);
};

export const getCode = (tel, imgCode) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getCode`, {tel, imgCode});
};
export const getCaptchaCode = (body) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getCode`, body);
};
export const getCaptcha = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Captcha/generate`);
};
export const verifyCaptcha = (code) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Captcha/verify?code=${code}`);
};

export const checkLoginStatus = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/user/checkLoginStatus`);
};

export const login = (tel, code, validDays) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/login`, {tel, code, validDays});
};

export const loginByOppoOid = oid => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/oauth/oppoCallBack?jsOauthLogin=1`, {
    oid
  });
};
export const loginByYoupin = ({redirectUri = '', openId, returnJson = 1}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/oauth/youpinCallBack`, {
    openId, redirectUri, returnJson
  });
};

export const getUserInfo = ntoken => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getUserInfo?token=${ntoken}`);
};

export const getOrderList = (pageIndex, pageSize, kw = '', type) => {
  kw = String(kw);
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/getOrderList?pageIndex=${pageIndex}&pageSize=${pageSize}&kw=${kw}&is_c2b=${type}`);
};

export const getOrderDetail = orderNum => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/getOrderInfo?orderNum=${orderNum}`);
};

export const getBannerConfig = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getBannerList`);
};

// 取消订单
export const cancelOrder = orderNum => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/cancelOrder?orderNum=${orderNum}`);
};

// 订单备注
export const orderRemark = (orderNum, content) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/remark`, {
    orderNum,
    content
  });
};

/**
 * 获取获取价格趋势(http://wiki.huishoubao.net/index.php?s=/101&page_id=1630)
 */
export const getProductPriceTrend = (productId, price) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getPriceHistory?productId=${productId}&price=${price}`);
};

/**
 * 获取回收方式列表
 */
export const getRecycleTypeList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getRecycleTypeList`);
};

/**
 * @desc: 获取本人下单时可以使用的优惠券
 * @mark: 不需要分页
 * @url: http://wiki.huishoubao.net/index.php?s=/101&page_id=1863
 */
export const getAllowCouponList = ({productList, recycleType = 0}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getAllowCouponList`, { productList, recycleType });
};

// 获取限时高价机型
export const getLimitedTime = (pageSize = 4) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/limitedTime?pageSize=${pageSize}`);
};

// 获取我的优惠券
export const getUserCouponList = ({ pageIndex = 1, pageSize = 100, status = '' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/getUserList`, { pageIndex, pageSize, status });
};

// 通过券码领取优惠券/券包
export const addByCode = ({ couponCode }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/addByCode`, { couponCode });
};

// 领取优惠券或券包
export const addCoupon = ({ id, isCouponParcel = 0, couponInfoShow = 1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/addByUser`, {id, isCouponParcel, couponInfoShow});
};

// 下单历史轮播
export const placeOrderHistory = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/order/placeOrderHistory`);
};

// 通过手机号码获取微信 openid
export const getOpenidByTel = ({ tel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getOpenidByTel`, { tel });
};

// 通过pid获取收款方式列表
export const getPayTypeList = ({ recycleType }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getPayTypeList`, { recycleType });
};

// 获取验证登录态方式
export const getCheckLoginWay = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getCheckLoginWay`);
};

// 绑定手机号码
export const bindTel = ({ code, tel, changBind }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/bind`, { code, tel, changBind });
};

// 更换手机号码
export const updateUserTel = ({ code, tel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/updateUserTel`, { code, tel });
};

// 获取活动机型
export const getActivityProducts = (id) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/open/getProductList?templateId=${id}`);
};

// 查看该手机号用户是否已存在
export const queryUserExist = ({ tel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/queryUserExist`, { tel });
};

// 获取PC首页导航数据
export const getCategoryBrandList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/getCategoryBrandList`);
};

export const getEvaluateHistoryTopH5 = type => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/product/topCoprate?type=${type}`);
};

// 获取流水记录（积分/余额/冻结金额）http://wiki.huishoubao.net/index.php?s=/101&page_id=4386
export const getTransList = ({ type, pageIndex, pageSize, returnAmount }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getTransList?type=${type}&=pageIndex=${pageIndex}&pageSize=${pageSize}&returnAmount=${returnAmount}`);
};

// 查询钱包金额信息 http://wiki.huishoubao.net/index.php?s=/101&page_id=4510
export const getBalanceInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/wallet/getBalanceInfo`);
};

// 提交订单时, 根据手机号码查询缓存的微信公众号openid或支付宝openid
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4609
export const getCacheInfoByTel = (tel, oauthSite) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/oauth/getInfo`, { tel, oauthSite });
};

// 生成支付宝、微信网页授权二维码接口
export const getOauthCode = (tel, oauthSite, redirectUri) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/qrc/getOauthCode`, { tel, oauthSite, redirectUri });
};

// 生成支付宝、微信网页授权二维码接口
export const getOauthCodeUri = (tel, oauthSite, redirectUri) => {
  const httpInstances = getHttpInstance();
  return `${httpInstances.apiHost}/api/qrc/getOauthCode?tel=${tel}&oauthSite=${oauthSite}&redirectUri=${redirectUri}`;
};

// 获取安卓app 下载地址 http://wiki.huishoubao.net/index.php?s=/101&page_id=4152
export const getAndroidAppDownloadUrl = (app = '2c-hsb') => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/common/checkUpdateAndroid?app=${app}&platform=6`);
};

export const getWxJsSign = (url) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/open/getJsSign`, {url});
};
export const getSupportNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/open/getSupportNum`);
};

// export const getConf = key => {
//   const httpInstances = getHttpInstance();
//   return httpInstances.http.get(`https://coo-cnf.huishoubao.com/getConf?key=${key}`);
// };

export const getAcitveConf = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/Coupon/get15Coupons`);
};

export const GetCouponById = (id, isCouponParcel = '0') => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/Coupon/GetCouponNum`, {id, isCouponParcel});
};

// 签到功能
export const sign = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/sign`);
};

// 查询签到状态
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4840
export const getSignStatus = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getSignStatus`);
};

// 获取签到页信息
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4849
export const getSignInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getSignInfo`);
};

// 获取签到页信息
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4843
export const getSignList = (year, month) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getSignList?month=${month}&year=${year}`);
};

// 上传图片签名
export const createUpdateSign = ({ fileName, path = '/iosjc/dev/', customPath = '/huanbaoshare/', uploadWay = 'tencentUpload' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/upload/getSign?path=${path}&customPath=${customPath}&uploadWay=${uploadWay}&fileName=${fileName}`);
};

// 生成带参数的小程序二维码
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4980
export const getWXACodeUnlimit = ({ scene, page, width }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wechat/getWXACodeUnlimit?scene=${scene}&page=${page}&width=${width}`);
};

// 获取生成环保证书的人数
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4981
export const getJoinNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getJoinNum`);
};

// 查询用户积分余额
export const getUserIntegralAmount = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wallet/getBalanceInfo`);
};

// 查询获奖用户列表
export const getPrizeUser = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/getPrizeUserList`);
};

// 抽奖
export const postPrize = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/luck`);
};

// 兑奖
export const getPrize = (obj) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/exchange`, {
    orderNum: obj.orderNum,
    userName: obj.userName,
    tel: obj.tel,
    address: obj.address
  });
};

// 查询奖品详情
export const getPrizeInfo = (obj) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/prize/getOrderInfo?orderNum=${obj.orderNum}&from=${obj.from}`);
};

// 查询奖品列报
// http://wiki.huishoubao.net/index.php?s=/101&page_id=4861
export const getPrizeList = (obj) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/getOrderList`, obj);
};

// 根据广告位置获取banner列表
export const getPositionBannerList = (positionCode, platform = 5) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/common/getPositionBannerList?positionCode=${positionCode}&platform=${platform}`);
};

// 查看用户是否领取了环保证书
export const isGenerateCertificate = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/isGenerateCertificate`);
};

// 查询是否已经领取过优惠券，同一个手机号在自有渠道只能领取一次
// http://wiki.huishoubao.net/index.php?s=/101&page_id=5045
export const couponGetReceivedStatus = ({ id, isCouponParcel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/getStatus?id=${id}&isCouponParcel=${isCouponParcel}`);
};
export const endStatusGet = ({ id, isCouponParcel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/endStatusGet?id=${id}&isCouponParcel=${isCouponParcel}`);
};

// 保存用户环保证书url
export const saveCertificateUrl = (path) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/saveCertificateUrl?path=${path}`);
};

// 获取环保证书url接口
export const getCertificateUrl = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getCertificateUrl`);
};
// --------------------------------------------------------------------------------------- 红包助力相关接口 start

// 获取用户是否领取过活动红包
export const rewardGetActivityRewardStatus = (activityId) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getActivityRewardStatus?activityId=${activityId}`);
};

// 获取用户任务列表
export const rewardGetTaskList = activityId => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getTaskList`);
};

// 获取提现用户列表
export const rewardGetWithdrawUserList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getWithdrawUserList`);
};

// 助力活动详情
export const rewardGetAssistInfo = (assistCode) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getAssistInfo?assistCode=${assistCode}`);
};

// 获取分享助力唯一编号
export const rewardGetShareAssistCode = activityId => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getShareAssistCode?activityId=${activityId}`);
};

// 获取助力活动高倍数用户列表
export const rewardGetAssistUserList = activityId => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getAssistUserList`);
};

// 助力翻倍
export const rewardAssist = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/assist`, params);
};

// 助力活动详情
export const getAssistInfo = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/getAssistInfo`, params);
};

// 清理活动数据
export const clearAssistInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/reward/clearActivityData`);
};
// --------------------------------------------------------------------------------------- 红包助力相关接口 end

// 用户是否领取了优惠券/查看了活动页
// export const miniAppIndexCoupon = () => {
//   const httpInstances = getHttpInstance();
//   return httpInstances.http.get(`${httpInstances.apiHost}/api/common/getPositionBannerList?positionCode=${positionCode}`);
// }

// 通过估价ID查询订单号
export const getOrderByGid = (gid) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/order/getOrderByGid?gid=${gid}&t=${Date.now()}`);
};

// 获取优惠券（二手节活动预热）
export const getCoupon = ({id}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.get(`${httpInstances.apiHost}/api/activity/exchangeCoupon?id=${id}`);
};
// 消耗贝币（二手节活动预热）
export const consume = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/consume`);
};
// 预约保存手机号（二手节活动预热）
export const savePhoneNum = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/savePhoneNum`, params);
};
// 批量查询产品信息
export const getAllProductInfo = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/getProduct`, params);
};
// 获取用户是否拥有补贴资格（oppo活动）
export const checkPartInActivity = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/oppo/checkPartInActivity?evalId=${params.evalId}`);
};
// 领取优惠券（618）
export const getActiveCoupon = ({ id, isCouponParcel = 0, couponInfoShow = 1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/addByUser`, {id, isCouponParcel, couponInfoShow});
};
// 预约攻略类型（618）
export const appointmentActivity = ({ address = '', tel, code, plan, type = 4 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/savePhone`, {address, tel, code, plan, type});
};
// 判断用户是否预约过活动（618）
export const checkAppointmentStatus = ({ plan, type = 4 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/recycle/checkStatus`, {plan, type});
};
// 判断优惠券状态
export const getReceivedStatus = ({ id, isCouponParcel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/coupon/endStatus?id=${id}&isCouponParcel=${isCouponParcel}`);
};
// 原价回收-首页用户参与状态
export const getWinStatus = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getWinStatus`);
};
// 原价回收-中奖纪录
export const getWinList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getWinList`);
};
// 原价回收-订单列表
export const getStoreOrderList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getOrderList`);
};
// 原价回收-确认订单
export const confirmStoreOrder = ({orderNum, orderType}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/confirmOrder`, {orderNum, orderType});
};
// 原价回收-马上抽奖
export const getLottery = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getLottery`);
};
// 原价回收二期-首页状态
export const getIndexStatus = ({shareId = ''}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getStatus`, {shareId});
};
// 原价回收二期-获取好友助力列表
export const getAssistList = ({ shareId, pageIndex = 1, pageSize = 5 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getAssistList`, { shareId, pageIndex, pageSize });
};
// 原价回收二期-获取助力总榜
export const getTotalAssistList = ({ pageIndex = 1, pageSize = 5 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getTotalAssistList`, { pageIndex, pageSize });
};
// 原价回收二期-获取中奖用户总榜
export const getUserPrizeList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/getPrizeList`);
};
// 原价回收二期-确认订单
export const userConfirmOrder = ({orderNum, orderType}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity618/confirmOrder2`, {orderNum, orderType});
};
// 原价回收二期-微信公众平台生成带场景参数二维码
export const buildCode = ({sceneStr, isReturnUrl = 1}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/wechat/qrcode`, {sceneStr, isReturnUrl});
};
// 获取当前系统时间
export const getSystemTime = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getSystemTime`);
};
// 上门回收预约
export const subscribe = ({productMode, tel, address}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/activity/subscribe`, {productMode, tel, address});
};
// 获取订单列表(新版订单)
export const getNewOrderList = ({type = 1, pageIndex = 1, pageSize = 20}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getOrderList`, {type, pageIndex, pageSize});
};
// 新增用户地址(新版订单)
export const addUserAddress = ({
  provinceName,
  provinceCode,
  cityName,
  cityCode,
  areaName,
  areaCode,
  address,
  userName,
  tel,
  isDefault = 0
}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/addressAdd`, {
    provinceName,
    provinceCode,
    cityName,
    cityCode,
    areaName,
    areaCode,
    address,
    userName,
    tel,
    isDefault
  });
};
// 获取用户地址列表(新版订单)
export const getUserAddress = ({pageIndex = 1, pageSize = 20}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/addressList`, {pageIndex, pageSize});
};
// 获取用户地址列表(新版订单)
export const delUserAddress = ({addrId}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/addressDel`, {addrId});
};
// 获取用户地址信息(新版订单)
export const getUserAddressInfo = ({addrId}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/addressQuery`, {addrId});
};
// 修改用户地址信息(新版订单)
export const editUserAddress = ({
  addrId,
  provinceName,
  provinceCode,
  cityName,
  cityCode,
  areaName,
  areaCode,
  address,
  userName,
  tel,
  isDefault = 0
}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/addressEdit`, {
    addrId,
    provinceName,
    provinceCode,
    cityName,
    cityCode,
    areaName,
    areaCode,
    address,
    userName,
    tel,
    isDefault
  });
};
// 获取用户订单信息(新版订单)
export const getUserOrderInfo = ({orderNum}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getOrderInfo`, {orderNum});
};
// 获取快递公司列表(新版订单)
export const getExpressList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getExpressCompanyList`);
};
// 手动关联快递单号(新版订单)
export const updateExpressNumber = ({orderNum, expressNumber, company}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/updateExpressNumber`, {orderNum, expressNumber, company});
};
// 获取取消原因列表(新版订单)
export const getCancelReasonList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getCancelReasonList`);
};
// 取消订单(新版订单)
export const newCancelOrder = ({orderNum, reason}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/cancel`, {orderNum, reason});
};
// 退货(新版订单)
export const refundGood = ({orderNum, userName, tel, province, city, area = '', address, reason}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/refund`, {orderNum, userName, tel, province, city, area, address, reason});
};
// 获取物流信息(新版订单)
export const getRouteList = ({orderNum}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getRouteList`, {orderNum});
};
// 有议价，客户同意回收(新版订单)
export const userAgree = ({orderNum}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/agree`, {orderNum});
};
// 下单(新版订单)
export const newCreateOrder = ({ evaluateid, tel, payType, regionId, recycleType, time, province, city, county, address, activityId, couponId, payAccount, payName, bankName, userName, imei, thirdCouponId, cardNumber, discountAmount, discountInfo, discountId, preOrderId, zmOrderNo, credFlag, sesameSignNo, externalNo, longitude, latitude }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/placeOrder`, {
    evaluateid,
    tel,
    payType,
    regionId,
    recycleType,
    time,
    province,
    city,
    county,
    address,
    activityId,
    couponId,
    payAccount,
    payName,
    preOrderId,
    discountId,
    discountInfo,
    discountAmount,
    bankName,
    userName,
    imei,
    // 第三方券ID， vivo 等
    thirdCouponId,
    // 快遞柜回收
    cardNumber,
    zmOrderNo,
    credFlag,
    sesameSignNo,
    externalNo,
    longitude,
    latitude
  });
};
// 查询剩余可以抽奖的次数
export const getLeftNum = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/prize/getLeftNum`);
};
// 获取退货物流信息(寄卖)
export const getRefundRouteList = ({orderNum, routeType}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/BangmaiV2/order/getRouteInfo`, {orderNum, routeType});
};
// 获取退货物流信息(普通)
export const getCommonRefundRouteList = ({orderNum, routeType}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getRouteInfo`, {orderNum, routeType});
};
export const getArticleInfo = ({articleId}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/article/getArticleInfo`, {articleId});
};
// h5-旧机换钱
export const getYjhxHistoryModel = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/product/getEvaluateHistoryTop`, params);
};
// 下单历史轮播-cocoh5
export const getPlaceOrderHistory = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/order/getHistoryOrderList`);
};
// 回收前端登录校验参数
export const checkClient = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/oauth/checkClient`, params);
};
// 回收前端登录获取code
export const getHsbCode = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/oauth/authorize`, params);
};
// 获取可乐优惠券
export const getCouponListFromYP = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/buy/getCouponListFromYP`, params);
};
// 渠道用户登录（CPS）
export const cpsLogin = (tel, code, validDays) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/user/cpsLogin`, {tel, code, validDays});
};
// 获取回收方式列表（CPS）
export const getCpsRecyleList = (regionId) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getRecyleList`, {regionId});
};
// 获取收款方式（CPS）
export const getCpsAccountInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/getAccountInfo`);
};
// 设置收款方式（CPS）
export const setCpsAccountInfo = (params) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/user/setAccountInfo`, params);
};
// 获取小站上门城市8城（CPS）
export const getXzCityList = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/common/getXzCityList`);
};
// 获取券的状态（618）
export const checkCouponStatus = ({ id, isCouponParcel }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/coupon/checkStatus?id=${id}&isCouponParcel=${isCouponParcel}`);
};
// 领取优惠券或券包（618）
export const addByUserNew = ({ id, isCouponParcel = 0, couponInfoShow = 1 }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/coupon/addByUser`, {id, isCouponParcel, couponInfoShow});
};
// 根据机器品牌码和spu机器码获取产品信息（vivo）
export const getNewReportInfo = ({ tamperNumber, system = '' }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/report/getReportInfo`, { tamperNumber, system });
};
// 退货(新版订单v5)
export const refundGoodNew = ({orderNum, userName, tel, province, city, area = '', address, reason}) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/order/refund`, {orderNum, userName, tel, province, city, area, address, reason});
};
// 获取挽回弹窗信息
export const getBulletInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/optimize/getBulletInfo`);
};
// 获取订单价格趋势
export const getOrderPriceTrend = ({ productId, price }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/V1/optimize/getPriceHistory`, { productId, price });
};
// CPS banner位
export const getCommonBannerConfig = ({ position }) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/common/getBannerList`, { position });
};
// CPS 钱包
export const getCPSBalanceInfo = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/wallet/getCpsBalanceInfo`);
};
export const themeSwitch = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/v5/common/themeSwitch`);
};



// WEBPACK FOOTER //
// ./src/apis/base.js